// /redeem — exact match (no code in URL).
//
// Used when a coach prints / pastes the code rather than handing out a
// direct link. RedeemFlow rendered with no urlCode → the «Код доступа»
// input is shown editable.

import { createFileRoute } from "@tanstack/react-router";

import { RedeemFlow } from "@/components/redeem/RedeemFlow";

export const Route = createFileRoute("/redeem/")({
  component: RedeemIndexPage,
});

function RedeemIndexPage() {
  return <RedeemFlow />;
}
